import { IIllustration } from './Illustration.model';
import { getIllustrationComponent } from './utils/getIllustrationComponent';

const Illustration = ({ ...props }: IIllustration) => {
  const Component = getIllustrationComponent(props.component);
  return <Component {...props} />;
};

export default Illustration;
